import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import axios from 'axios';
import UserExpenseView from './UserExpenseView';
import Example from './Example';
import Example1 from './Example1';

import { Dropdown } from 'semantic-ui-react'
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import apiBaseUrl from './API'

const style = {
    margin: 100,
  };
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 1500,
  },
  group: {
    width: 'auto',
    height: 'auto',
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'row',
}
}));



export default function FullWidthTabs(props) {

  console.log('&&& ', props)
  console.log('&&& ', props.userid)

  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const [cname, setCname] = React.useState('');
  const [pname, setPname] = React.useState('');
  const [location, setLocation] = React.useState('');
  const [bike, setBike] = React.useState(0);
  const [bikeKM, setBikeKM] = React.useState(0);
  const [description, setDescription] = React.useState('');

  const [car, setCar] = React.useState(0);
  const [bus, setBus] = React.useState(0);
  const [train, setTrain] = React.useState(0);
  const [flight, setFlight] = React.useState(0);
  const [food, setFood] = React.useState(0);
  const [hotel, setHotel] = React.useState(0);
  // const [date, setDate] = React.useState(new Date());


  const [customerNames, setCustomerNames] = React.useState([{}]);
  const [selectedCustomer, setSelectedCustomer ] = React.useState('');
  const [locationNames, setLocationNames] = React.useState([{}]);
  const [selectedLocation, setSelectedLocation ] = React.useState('');

  const [projectNames, setProjectNames] = React.useState([{}]);
  const [selectedProject, setSelectedProject ] = React.useState('');

  const [projectCodes, setProjectCodes] = React.useState([{}]);
  const [selectedProjectCode, setSelectedProjectCode ] = React.useState('');

  const [total, setTotal ] = React.useState();
  const [value1, setValue1] = React.useState('');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChange1 = (event, newValue) => {
    setValue1(newValue);
  };
 
  const handleChangeIndex = (index) => {
    setValue(index);
  };

  //const [selectedDate, handleDateChange] = React.useState(new Date());
  const [startDate, setStartDate] = React.useState(new Date());


  const handleDateChange =(d) =>{
    setStartDate(d)
  } 
  function reset(){
    setCname('');
    setPname('');
    setBike(0);
     
  
  }
  
  const handleClick = e => {
    e.preventDefault();
    //e.target.reset();
   console.log("CLICK ", {cname}.cname)

   //console.log("TETS CC ", customerNames.map())
 

   // console.log("values in register handler",role);
   var self = this;
   //To be done:check for empty values before hitting submit
   //if(this.state.name.length>0 && this.state.email.length>0 && this.state.password.length>0){
     console.log("payload ", props.tlid)
     var payload={
     "userid": props.userid,
     "location": selectedLocation,
     "cust_name": selectedCustomer,
     "project_name": selectedProject,
     "project_code": selectedProjectCode,
     "bike_type" :value1,
     "bike":{bike}.bike,
      "bike_KM" : bikeKM,
     "car": {car}.car,
     "bus": {bus}.bus,
     "flight": {flight}.flight,
     "train": {train}.train,
     "food": {food}.food,
     "hotel": {hotel}.hotel,  
     "date" : startDate,
     "status" : "Pending",
     "description": description,
     "total" : total,
     "tl_id": props.tlid
     }
     axios.post(apiBaseUrl+'/postExpense', payload)
    .then(function (response) {
      console.log(response);
      if(response.data.code === 200){
         console.log("Expense successfull");
         setSelectedCustomer('')
         handleChange1('')
         setBikeKM(0)
         setBike(0)
         setCar(0)
         setBus(0)
         setTrain(0)
         setFood(0)
         setHotel(0)
         setDescription('')
         setStartDate(new Date())
         handleChangeIndex(1)
          // reset after form submit
        // var loginscreen=[];
        // loginscreen.push(<Login parentContext={this} appContext={self.props.appContext} role={role}/>);
        // var loginmessage = "Not Registered yet.Go to registration";
        // self.props.parentContext.setState({loginscreen:loginscreen,
        // loginmessage:loginmessage,
        // buttonLabel:"Register",
        // isLogin:true
        //  });
      }
      else{
        console.log("some error ocurred",response.data.code);
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  
  //  else{
  //    alert("Input field value is missing");
  //  }

  };

  React.useEffect(() => {
    async function fetchData() {
      const res = await fetch(apiBaseUrl+'/customerNames');
      res
        .json()
        .then(res =>  setCustomerNames(res))
        .catch();
    }
    

    fetchData();
  },[]);

  React.useEffect(() => {

   
    async function fetchData() {
      const res = await fetch(apiBaseUrl+'/customerNamesLocation?cid='+selectedCustomer);
      res
        .json()
        .then(res =>  setLocationNames(res))
        .catch();
    }
   
    fetchData();
  },[selectedCustomer]);

  React.useEffect(() => {

   
    async function fetchData() {
      const res = await fetch(apiBaseUrl+'/projectNames?cid='+selectedCustomer+'&lid='+selectedLocation);
      res
        .json()
        .then(res =>  setProjectNames(res))
        .catch();
    }
   
    fetchData();
  },[selectedLocation,selectedCustomer]);

  React.useEffect(() => {

   
    async function fetchData() {
      const res = await fetch(apiBaseUrl+'/projectCodes?cid='+selectedCustomer+'&lid='+selectedLocation+'&pid='+selectedProject);
      res
        .json()
        .then(res =>  setProjectCodes(res))
        .catch();
    }
   
    fetchData();
  },[selectedLocation,selectedCustomer, selectedProject]);

  React.useEffect(() => {

  
     setTotal((parseInt(bike)+parseInt(car)+parseInt(bus)+parseInt(train)+parseInt(bikeKM*3)+parseInt(food)+parseInt(hotel)))
  },[bike,car,bus, train, food, hotel,  bikeKM, value1]);


  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label="Add New expense" {...a11yProps(0)} />
          <Tab label="View Expenses" {...a11yProps(1)} />
          {/* <Tab label="Item Three" {...a11yProps(2)} /> */}
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
      <TabPanel value={value} index={0} dir={theme.direction}>
            
        <MuiThemeProvider>
          <div>
          <p>Select The Customer Name</p> 
           <Select onChange={e => setSelectedCustomer(e.target.value)}>{
                customerNames.map((obj) => {
                     return <MenuItem value={obj.id}>{obj.cname}</MenuItem>
                 })
              }</Select>
             <br></br>
             {/* <p>THE SELECTED CUST {selectedCustomer}</p> */}
             <p>Select The Location</p>

            <Select onChange={e => setSelectedLocation(e.target.value)}>{
               locationNames.code == 204 ? <MenuItem value="">" "</MenuItem>  : locationNames.map((obj) => {
                     return <MenuItem value={obj.id}>{obj.location}</MenuItem>
                 })
              }</Select>
               <br/>

               <p>Select The Project Name</p>

               <Select onChange={e => setSelectedProject(e.target.value)}>{
               projectNames.code == 204 ? <MenuItem value="">" "</MenuItem>  : projectNames.map((obj) => {
                     return <MenuItem value={obj.id}>{obj.project_name}</MenuItem>
                 })
              }</Select>
             <br/>
            
             <p>Select The Project Code</p>

               <Select onChange={e => setSelectedProjectCode(e.target.value)}>{
               projectCodes.code == 204 ? <MenuItem value="">" "</MenuItem>  : projectCodes.map((obj) => {
                     return <MenuItem value={obj.id}>{obj.project_code}</MenuItem>
                 })
              }</Select>
             <br/>
              <br></br>

            <FormControl component="fieldset">
              <FormLabel alignItems="center"  component="legend">Type of Bike</FormLabel>
                <RadioGroup   className={classes.group}
                aria-label="Type of Bike"  row={true} name="typeofbike" value={value1} onChange={handleChange1}>
                  <FormControlLabel   value="personalBike" control={<Radio />} label="Personal Bike" />
                  <FormControlLabel   value="officeBike" control={<Radio />} label="Office Bike" />
            
                </RadioGroup>
           </FormControl>
           <br></br>

           { value1 ==  "officeBike" ? <TextField
               value = {bike}
               type="number"
               hintText="Bike Expense"
               floatingLabelText="Bike Expense"
               errorText= {bike === ""? "Enter integer value or 0 if there is no expense": ""}
               onChange = {e => setBike(e.target.value)} 
               /> : <TextField
               value = {bikeKM}
               type="number"
               hintText="KM Driven"
               floatingLabelText="KM Driven"
               errorText= {bike === ""? "Enter integer value or 0 if there is no expense": ""}
               onChange = {e => setBikeKM(e.target.value)} 
                /> }  
            { value1 ==  "personalBike" ? <p> The price is KM x 3 :  {bikeKM*3}</p> :""}
               <br/>
                        
              <TextField 
               value = {car} 
               type="number"
               hintText="Local Travel Expense"
               floatingLabelText="Local Travel Expense"
               onChange = {e => setCar(e.target.value)}
               /><br/>

              <TextField
               value = {bus}
               type="number"
               hintText="Bus Expense"
               floatingLabelText="Bus Expense"
               onChange = {e => setBus(e.target.value)}
               /><br/>

              <TextField
               value = {train}
               type="number"
               hintText="Train Expense"
               floatingLabelText="Train Expense"
               onChange = {e => setTrain(e.target.value)}
               /><br/> 
                 
              <TextField
               value = {flight}
               type="number"
               hintText="Flight Expense"
               floatingLabelText="Flight Expense"
               onChange = {e => setFlight(e.target.value)}
               /><br/>

              <TextField
               value = {food}
               type="number"
               hintText="food"
               floatingLabelText="food"
               onChange = {e => setFood(e.target.value)}
               /><br/>

              <TextField
               value = {hotel}
               type="number"
               hintText="Accomdation/ Hotel"
               floatingLabelText="Accomdation/ Hotel"
               onChange = {e => setHotel(e.target.value)}
               /><br/>

              {/* <TextField
               value = {description}
               type="text"
               hintText="Status of the project"
               floatingLabelText="Status of the project"
               onChange = {e => setDescription(e.target.value)}
               /><br/> */}
              <TextareaAutosize
                rowsMin={10}
                value = {description}
                aria-label="maximum height"
                placeholder="Status of the project"
                onChange = {e => setDescription(e.target.value)}
              />
            <p>Choose the date</p>  <DatePicker
                selected={startDate}
                onSelect={handleDateChange} //when day is clicked
                onChange={handleDateChange} //only when value has changed  TEAM LEADEer VERIFY OPTION // ADMIN -> TRANSFERED  
              />

             <br></br>
              <TextField
               value = {total}
               hintText="Total Amount"
               floatingLabelText="Total Amount in rupees"

              /><br/>
             <RaisedButton label="Submit" primary={true} style={style} onClick={(event) =>handleClick(event)}/>
             </div>
         </MuiThemeProvider>
         

         </TabPanel>
         <TabPanel value={value} index={1} dir={theme.direction}>

          <UserExpenseView role = "user" userid = {props.userid}/>

         </TabPanel>
        {/* <TabPanel value={value} index={2} dir={theme.direction}>
          
        <Example1 />

         </TabPanel> */}
      </SwipeableViews>
    </div>
  );
}




// WEBPACK FOOTER //
// ./src/User.js